'use strict';

import './../ext/jquery-ui';
import './../ext/datepicker-pl';

export default function datepicker() {
    let $datepicker = $('.js-datepicker');

    if (!$datepicker.length) {
        return;
    }

    $.datepicker.setDefaults($.datepicker.regional[$('html').attr('lang')]);

    $('.js-datepicker').datepicker({
        dateFormat: 'yy-mm-dd',
        minDate: new Date()
    });
}
